import { peek, selector } from 'lib/selectors'
import { StateInterface } from 'types/state'

const jobs = (state: StateInterface) => state.jobs

export const jobNotesSelector = selector(jobs, peek('notes'))
export const candidateJobNotesSelector = selector(jobs, peek('candidateNotes'))
export const extractedSkillsSelector = selector(jobs, peek('extractedSkills'))
